'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Drawers = function () {
  function Drawers(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Drawers);

    this.els = {
      el: el,
      html: (0, _functional.getElement)('html'),
      body: document.body,
      backdrop: (0, _functional.getElement)('.js-Drawers_Backdrop')
    };
    this.matches = {
      trigger: '[data-module-drawers-trigger]',
      close: '[data-module-drawers-close]',
      backdrop: '.js-Drawers_Backdrop'
    };
    this.classes = {
      activeClass: 'drw-Drawers-active',
      activeDrawerClass: 'drw-Drawer-active',
      activeTrigger: 'js-Drawers-triggerActive',
      activeBody: 'js-Drawers-active',
      siteOverflowed: 'util-SiteOverflowed',
      setHeight: 'util-setHeight'
    };
    this._activeDrawerKey = '';
    this.foundDrawers = (0, _functional.getElements)(this.matches.trigger).reduce(function (acc, el) {
      var key = el.dataset.moduleDrawersTrigger;
      acc[key] = _this.buildDrawer(key, el);

      return acc;
    }, {});

    this.setupListeners();

    window.drawers = this;

    this.activeDrawerKey = '';
  }

  (0, _createClass3.default)(Drawers, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      this.els.body.addEventListener('click', function (e) {
        var target = e.target;


        if (target.closest(_this2.matches.trigger) === false && target.closest(_this2.matches.close) === false && target.closest(_this2.matches.backdrop) === false) {
          return;
        }

        if (target.closest(_this2.matches.trigger)) {
          e.preventDefault();
          var matches = target.closest(_this2.matches.trigger);
          var key = matches.dataset.moduleDrawersTrigger;

          if (key in _this2.foundDrawers === false || key in _this2.foundDrawers && _this2.drawerIsComplete(key) === false) {
            _this2.foundDrawers[key] = _this2.buildDrawer(key, matches);
          }

          var foundDrawer = _this2.foundDrawers[key];
          foundDrawer.triggers.forEach(function (trigger) {
            return trigger.classList.toggle(_this2.classes.activeTrigger, _this2.activeDrawerKey !== key && _this2.foundDrawers[key].isToggle);
          });

          if (foundDrawer.isToggle && _this2.activeDrawerKey === key) {
            _this2.activeDrawerKey = '';

            return;
          }

          _this2.activeDrawerKey = key;
        }

        if (target.closest(_this2.matches.close)) {
          _this2.activeDrawerKey = '';
        }

        if (target.closest(_this2.matches.backdrop)) {
          _this2.activeDrawerKey = '';
        }
      });
    }
  }, {
    key: 'buildDrawer',
    value: function buildDrawer(key, matches) {
      return {
        triggers: (0, _functional.getElements)('[data-module-drawers-trigger="' + key + '"]'),
        drawer: (0, _functional.getElement)('[data-module-drawers-drawer="' + key + '"]'),
        close: (0, _functional.getElement)('[data-module-drawers-close="' + key + '"]'),
        isToggle: matches.hasAttribute('data-module-drawers-trigger-toggle')
      };
    }
  }, {
    key: 'drawerIsComplete',
    value: function drawerIsComplete(key) {
      return Object.values(this.foundDrawers[key]).filter(function (val) {
        return val != null;
      }).length === 0;
    }
  }, {
    key: 'tiktokInitiaiteCheckout',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var value, contentsArray, cartArray, i, contentObj;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /* eslint-disable */
                value = Number(document.querySelector('[data-pushcart-total]').dataset.pushcartTotal / 100);
                contentsArray = [];
                cartArray = document.querySelectorAll('.crt-Push_Item');


                for (i = 0; i < cartArray.length; i++) {
                  contentObj = {};


                  contentObj.content_id = cartArray[i].dataset.id;
                  contentObj.content_name = cartArray[i].querySelector('.crt-PushItem_TitleLink').innerText.trim();
                  contentObj.content_type = 'product';
                  contentObj.content_category = 'product';
                  contentObj.quantity = Number(cartArray[i].querySelector('.crt-PushItem_Select').value);
                  contentObj.price = Number(cartArray[i].querySelector('.crt-PushItem_Price').dataset.price / 100);
                  contentObj.description = cartArray[i].dataset.description;

                  contentsArray.push(contentObj);
                }

                if (window.theme.enableTiktokTracking === true) {
                  ttq.instance(tiktok_id).track('InitiateCheckout', {
                    contents: contentsArray,
                    value: value,
                    currency: window.theme.currency
                  });
                }
                /* eslint-enable */

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function tiktokInitiaiteCheckout() {
        return _ref.apply(this, arguments);
      }

      return tiktokInitiaiteCheckout;
    }()
  }, {
    key: 'activeDrawerKey',
    get: function get() {
      return this._activeDrawerKey;
    },
    set: function set(val) {
      var _this3 = this;

      this._activeDrawerKey = val;

      this.els.body.classList.toggle(this.classes.siteOverflowed, val !== '');
      this.els.body.classList.toggle(this.classes.activeBody, val !== '');
      this.els.html.classList.toggle(this.classes.setHeight, val !== '');

      if (val !== '') {
        this.els.body.setAttribute('data-active-drawer', val);
      } else {
        this.els.body.removeAttribute('data-active-drawer', val);
      }

      if (val === 'search') {
        var headerSearchInput = document.querySelector('[data-drawers-external-el="headerSearchInput"]');
        if (headerSearchInput) {
          headerSearchInput.value = '';
          setTimeout(function () {
            headerSearchInput.focus();
          }, 250);
        }
      }

      Object.entries(this.foundDrawers).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        if (value.drawer) {
          var drawerContainer = value.drawer.closest('.drw-Drawers');
          if (drawerContainer) {
            drawerContainer.classList.toggle(_this3.classes.activeClass, key === val);
          }

          value.drawer.classList.toggle(_this3.classes.activeDrawerClass, key === val);
        }

        if (value.isToggle) {
          value.triggers.forEach(function (trigger) {
            return trigger.classList.add(_this3.classes.activeTrigger);
          });
        }

        if (value.isToggle && key !== val) {
          value.triggers.forEach(function (trigger) {
            return trigger.classList.remove(_this3.classes.activeTrigger);
          });
        }

        if (key === 'cart' && document.body.classList.contains('lyt-Site-showHeader') === false) {
          document.body.classList.add('lyt-Site-showHeader');
        }

        if (key === 'cart' && window.theme.enableTiktokTracking === true) {
          document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              _this3.tiktokInitiaiteCheckout();
            });
          });
        }
      });
    }
  }]);
  return Drawers;
}();

exports.default = Drawers;